import { Box } from "@mui/material";
import React, { useContext } from "react";
import { StyledLoginCard } from "./Onboarding.styles";
import { useIntl } from "react-intl";
import { useOnboardingState } from "./OnboardingProvider";

export default function ChooseEcoSystem() {
  const { formatMessage } = useIntl();
  const { chooseEcoSystem } = useOnboardingState();

  const ecoSystemsOption = [
    {
      name: formatMessage({ id: "global.blockchain.evm" }),
      img: require("assets/img/evm.svg").default,
    },
    {
      name: formatMessage({ id: "global.blockchain.solana" }),
      img: require("assets/img/solana.svg").default,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        pt: "125px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FAFAFD",
      }}>
      <Box width={"400px"} sx={{ textAlign: "center" }}>
        <img
          src={require("assets/img/onboardingLogo.png")}
          alt="MetaCRM Logo"
        />
        <Box color="#383538" fontSize="24px" fontWeight={700}>
          {formatMessage({ id: "global.welcome.title" })}.
        </Box>
        <Box color="#777" fontSize="14px" mb="32px" mt={"4px"}>
          {formatMessage({ id: "global.welcome.subtitle" })}
        </Box>
        {ecoSystemsOption.map((ecoSystem) => (
          <StyledLoginCard
            key={ecoSystem.name}
            onClick={() => chooseEcoSystem(ecoSystem.name)}>
            <img
              src={ecoSystem.img}
              style={{ width: 36, height: 36 }}
              alt={`${ecoSystem.name} logo`}
            />
            <Box ml="12px">{ecoSystem.name}</Box>
          </StyledLoginCard>
        ))}
      </Box>
    </Box>
  );
}
